'use client';

import { MarketingHero } from '@/components/marketing/MarketingHero';
import { FeatureGrid } from '@/components/marketing/FeatureGrid';
import { MarketingCTA } from '@/components/marketing/MarketingCTA';
import { FAQ } from '@/components/marketing/FAQ';

export default function MarketingHomePage() {
  return (
    <div className="min-h-screen">
      <MarketingHero />
      <FeatureGrid />
      <MarketingCTA />
      <FAQ />
    </div>
  );
}
